"use client";

import {
    useState,
    useEffect
} from "react";
import {
    Card,
    Table
} from "react-bootstrap";
import {
    useNavigate
} from "react-router-dom";
import { getToken } from "../../../../utils/auth";

const TableUser = () => {
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const navigate = useNavigate();

    // Helper to get Authorization headers
    const getAuthHeaders = () => {
        const token = getToken();
        return token ? {'Authorization': `Bearer ${token}`} : {};
    };

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/user/get-users`, {
            headers: {
                ...getAuthHeaders(),
            },
        })
            .then((res) => res.json())
            .then((result) => {
                setData(result);
            })
            .catch((error) => {
                console.error("Error fetching users:", error);
            });
    }, []);

    const totalItems = data.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const paginatedData = data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleAddNew = () => {
        navigate("/tuvien/suauser", {
            state: {
                row: null,
                mode: "add"
            }
        });
    };

    const handleEdit = (row) => {
        navigate("/tuvien/suauser", {
            state: {
                row,
                mode: "edit"
            }
        });
    };

    const handleDeleteOrRestore = async (row) => {
        if (window.confirm(`Delete UserId: ${row.id}?`)) {


            const isDelete = !row.isDelete;

            const objUpdate = {
                id: row.id,
                isDelete: isDelete
            }

            // Call backend API to delete user
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/user/delete-user`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        ...getAuthHeaders(),
                    },
                    body: JSON.stringify(objUpdate)
                });
                if (response.ok) {
                    // setData(prev => prev.filter(item => item.id !== row.id));

                    setData(prev => prev.map(item => item.id === row.id ? {
                        ...item,
                        isDelete
                    } : item));
                    
                } else {
                    alert("Delete failed");
                }
            } catch (err) {
                alert("Network error: " + err.message);
            }
        }
    };

    const [pageInput, setPageInput] = useState(currentPage);
    useEffect(() => {
        setPageInput(currentPage);
    }, [currentPage]);

    const handleInputChange = (e) => {
        setPageInput(e.target.value.replace(/\D/, ""));
    };

    const handleInputBlur = () => {
        let page = parseInt(pageInput, 10);
        if (!page || page < 1) page = 1;
        if (page > totalPages) page = totalPages;
        setCurrentPage(page);
    };

    const handleInputKeyDown = (e) => {
        if (e.key === "Enter") {
            handleInputBlur();
        }
    };

    return (
        <Card
            className="bg-white border-0 rounded-3 mb-4">
            <Card.Body
                className="p-0">
                <div
                    className="p-4">
                    <div
                        className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                        <h3 className="mb-0">Danh
                            sách
                            người
                            dùng</h3>
                        <button
                            className="btn btn-primary"
                            onClick={handleAddNew}>Thêm
                            mới
                        </button>
                    </div>
                </div>
                <div
                    className="default-table-area style-two all-projects">
                    <div
                        className="table-responsive">
                        <Table
                            className="align-middle">
                            <thead>
                            <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Username</th>
                                <th scope="col">Email</th>
                                <th scope="col">Ngày
                                    tạo
                                </th>
                                <th scope="col">Đã
                                    xóa
                                </th>
                                <th scope="col"></th>
                            </tr>
                            </thead>
                            <tbody>
                            {paginatedData.map((value, i) => (
                                <tr key={i}>
                                    <td>{value.id}</td>
                                    <td>{value.username}</td>
                                    <td>{value.email}</td>
                                    <td>{value.created_at}</td>
                                    <td>{value.isdelete ? "Yes" : "No"}</td>
                                    <td>
                                        <button
                                            className="btn btn-sm btn-warning me-2"
                                            onClick={() => handleEdit(value)}>Sửa
                                        </button>
                                        <button
                                            className={`btn btn-sm ${value.isDelete ? 'btn-success' : 'btn-danger'}`}
                                            onClick={() => handleDeleteOrRestore(value)}>
                                            {value.isDelete ? 'Mở' : 'Xóa'}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </div>
                    <div
                        className="p-4 pt-lg-4">
                        <div
                            className="d-flex flex-column align-items-center text-center gap-2 showing-wrap">
                            <span
                                className="fs-12 fw-medium mb-2">
                                Showing {paginatedData.length} of {totalItems} Results
                            </span>
                            <nav
                                aria-label="Page navigation example">
                                <ul className="pagination mb-0 justify-content-center align-items-center gap-2">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link icon"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}>
                                            <span
                                                className="material-symbols-outlined">keyboard_arrow_left</span>
                                        </button>
                                    </li>
                                    <li className="page-item d-flex align-items-center">
                                        <input
                                            type="text"
                                            value={pageInput}
                                            onChange={handleInputChange}
                                            onBlur={handleInputBlur}
                                            onKeyDown={handleInputKeyDown}
                                            style={{
                                                width: "40px",
                                                height: "32px",
                                                textAlign: "center",
                                                border: "1px solid #ced4da",
                                                borderRadius: "4px",
                                                fontSize: "14px",
                                                padding: "2px 6px"
                                            }}
                                            className="form-control d-inline-block mx-2"
                                        />
                                        <span
                                            style={{
                                                fontSize: "14px",
                                                marginLeft: "4px"
                                            }}> / {totalPages}</span>
                                    </li>
                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button
                                            className="page-link icon"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}>
                                            <span
                                                className="material-symbols-outlined">keyboard_arrow_right</span>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

export default TableUser;
